import * as Sentry from '@sentry/tanstackstart-react';
import { createClientOnlyFn } from '@tanstack/react-start';

const CLIENT_TRACES_SAMPLE_RATE = 0.1;
const capturedErrorObjects = new WeakSet<object>();
const capturedPrimitiveErrors = new Set<string>();

let hasInitializedBrowserSentry = false;

interface InitBrowserSentryOptions {
	dsn: string;
	environment: string;
	router: unknown;
}

const initBrowserSentryClient = createClientOnlyFn((options: Readonly<InitBrowserSentryOptions>) => {
	if (hasInitializedBrowserSentry) {
		return;
	}

	hasInitializedBrowserSentry = true;

	Sentry.init({
		dsn: options.dsn,
		environment: options.environment,
		integrations: [Sentry.tanstackRouterBrowserTracingIntegration(options.router)],
		tracesSampleRate: CLIENT_TRACES_SAMPLE_RATE,
	});
});

const captureClientRootErrorFn = createClientOnlyFn((error: unknown) => {
	if (error && typeof error === 'object') {
		if (capturedErrorObjects.has(error)) {
			return;
		}

		capturedErrorObjects.add(error);
	} else {
		const errorKey = String(error);
		if (capturedPrimitiveErrors.has(errorKey)) {
			return;
		}

		capturedPrimitiveErrors.add(errorKey);
	}

	Sentry.captureException(error);
});

export function initBrowserSentry(options: Readonly<InitBrowserSentryOptions>): void {
	void initBrowserSentryClient(options);
}

export function captureClientRootError(error: unknown): void {
	void captureClientRootErrorFn(error);
}
